import React, { useState } from "react";

const ConsultingEntryRequirements = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Direct Route",
      content: `Applicants who do not meet the ESBD Route criteria can apply through the Direct Route.

- Academic Qualifications: Hold a recognised Bachelor’s degree or equivalent qualification from an 
accredited institution.

- Professional Experience: Demonstrate relevant leadership or consulting experience in professional, 
academic, or community settings, highlighting initiative & problem-solving skills.

- Programme Progression: Applicants will complete one of the pathways—Certified Business Consultant
Programme or Certified Executive Career Coach Programme—before advancing to the Master’s Stage.`,
    },
    {
      id: 2,
      title: "ESBD Route",
      content: `Applicants who have already completed either The Certified Business Consultant Programme or The
Certified Executive Career Coach Programme (60 ECTS) at ESBD may directly enter the Master’s
Stage.

**Programme Progression**
Students in this route will only need to complete the 30 ECTS Master’s Stage.
`,
    },
    {
      id: 3,
      title: "Proof of Proficiency in the English Language",
      content: `The following qualifications meet our English language requirement:
- Native English speakers
- TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)
- IELTS (Minimum score: 5.5)
- Cambridge ESOL (CAE, Minimum score: C1)
- English as the language of instruction in formal education
- Equivalent qualifications you wish to be considered`,
    },
    {
      id: 4,
      title: "Identity Check",
      content: `Applicants must submit a valid ID during application & verify their identity via a live Zoom session
at the start of the course.`,
    },
  ];

  return (
    <div className="md:scroll-mt-44 scroll-mt-16 my-10" id="entry-requirements">
      <div className="bg-sddarkgray py-5">
        <div className="max-w-6xl mx-auto px-10 space-y-5">
          <h2 className="text-xl font-bold mb-4 text-gray-50">
            Entry Requirements
          </h2>
          <div className="bg-gray-50 h-1 w-14 "></div>
          <div className="space-y-1">
            {sections.map((section) => (
              <div key={section.id} className="border-y border-black">
                <button
                  onClick={() => handleToggle(section.id)}
                  className="w-full text-left py-2 px-3 bg-blue-50 hover:bg-blue-100 focus:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-medium">{section.title}</span>
                    <span>{activeSection === section.id ? "▲" : "▼"}</span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-3 py-2 bg-sdbodywhite border-t border-gray-300">
                    <p className="text-gray-700 whitespace-pre-line">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultingEntryRequirements;
